export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/wishlistedIcon.65dc1eca.svg","height":13,"width":15,"blurWidth":0,"blurHeight":0};